import { useEffect, RefObject } from 'react';

import { finleyAssert } from '@finley-technologies/common';

const _isEventNodeType = (event: EventTarget | null): event is Node => {
  return !!event && 'nodeType' in event;
};

export const useMousedownListeners = <T extends HTMLElement>(
  ref: RefObject<T>,
  clickFns: {
    insideClickFn?: () => void;
    outsideClickFn?: () => void;
  },
): void => {
  useEffect(() => {
    const handleClick = ({ target }: MouseEvent) => {
      if (!ref.current) {
        return;
      }

      finleyAssert(_isEventNodeType(target), 'event is not "Node" type');
      const clickedInsideElement = ref.current.contains(target);
      if (clickedInsideElement) {
        clickFns.insideClickFn?.();
      } else {
        clickFns.outsideClickFn?.();
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClick);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClick);
    };
  }, [clickFns, ref]);
};
